module.exports = __webpack_public_path__ + "img/wmpy.0608500c.jpg";